import Dashboard from "~/layouts/Dashboard/Dashboard";
import { Login, Logout, Callback } from "~/views/Authentication";
import ProtectedRoute from "~/components/Common/ProtectedRoute";
import { USE_COOKIE_AUTH } from "~/services/authConstants";

const indexRoutes = [
  { path: "/login", component: Login },
  { path: "/logout", component: Logout },
  ...(!USE_COOKIE_AUTH ? [{ path: "/callback", component: Callback }] : []),
  { path: "/", component: ProtectedRoute(Dashboard) },
];

export default indexRoutes;
